import Transports from './models/transports'
import Api from './api'

import CartItem from './models/cart/cart-item'

import CartStore from './stores/cart'
import ProductStore from './stores/product'
import UserStore from './stores/user'

class Core {
  constructor() {
    this.fqn = 'oat-core';

    this.api = null;
    this.data = null;
  }

  init({ store, transports }) {
    return new Promise((resolve, reject) => {
      const t = new Transports(transports);
      const curry = store.state.bootstrap.data.curry;

      this.api = new Api({ config: curry, transports: t });

      this.api.init(store.state.bootstrap.i18n.locales)
        .then((data) => {
          this.data = data;

          this.stores.forEach(s => {
            store.registerModule(s.name, {
              state: s.state,
              actions: s.actions,
              mutations: s.mutations, 
            });
          });

          resolve();
        }).catch((error) => { 
          reject(error);
        });
    });
  }

  get stores() {
    const stores = [
      new CartStore({
        api: this.api,
        cart: this.data.cart,
        catalog: this.data.catalog,
        embed: this.data.embed,
        order: this.data.order,
        paymentMethods: this.data.paymentMethods,
        shop: this.data.shop,
        tables: this.data.tables,
      }),
      new ProductStore({ api: this.api }),
      new UserStore({ 
        api: this.api, 
        user: this.data.user,
        services: this.data.services
      }),
    ];
    return stores;
  }
}

export default Core

export {
  CartItem
}